export const thirdPartyCookieBlockedError = 'SecurityError';
